export class TicketAssignMemberRequest {
    MemberID: number;
    TicketID: number;
}
